let autoRedirectStartedAt: number | null = null
let appEntryAt: number | null = null

export const markAutoRedirectStarted = (): void => {
  autoRedirectStartedAt = performance.now()
}

/**
 * Anchors the "full load" measurement at the earliest app code (called from `main.tsx`), before the
 * userConfig fetch, React mount, routing, and the /doc -> /design-exploration redirect. Set once per
 * document: a repeat call is ignored so a re-import or hot reload cannot move the anchor forward. A
 * genuine page reload creates a fresh document, re-runs `main.tsx`, and re-anchors from zero.
 */
export const markAppEntry = (): void => {
  if (appEntryAt === null) appEntryAt = performance.now()
}

/**
 * Returns ms elapsed since `markAppEntry()`, or null if it never ran. Anchored at app entry rather
 * than `performance.timeOrigin`, so the value is bounded to the app's own boot-to-Landing window and
 * excludes time the host EHR iframe spent backgrounded or recycled before our code started running.
 */
export const getFullLoadDuration = (): number | null => {
  if (appEntryAt === null) return null
  return Math.round(performance.now() - appEntryAt)
}

/** Returns the `markAppEntry()` time as epoch ms, or null if it never ran. */
export const getAppEntryEpochMs = (): number | null => {
  if (appEntryAt === null) return null
  return performance.timeOrigin + appEntryAt
}

/**
 * Returns ms elapsed since `markAutoRedirectStarted()` last ran, or null if no
 * autoredirect was marked (e.g. user landed directly on /design-exploration).
 * Clears the anchor so subsequent reads return null until the next mark.
 */
export const consumeAutoRedirectDuration = (): number | null => {
  if (autoRedirectStartedAt === null) return null
  const durationMs = Math.round(performance.now() - autoRedirectStartedAt)
  autoRedirectStartedAt = null
  return durationMs
}
